const Divider = () => {
  return (
    <div className='mx-1 h-3.5 w-[1px] bg-divider-regular'></div>
  )
}

export default Divider
